import React, { useMemo } from 'react';

// DEPENDENCIES
import { useFormikContext } from 'formik';

// CORE COMPONENTS
import Form from 'core/form/Form';

// GLOBAL PARTS
import Card from 'parts/card/Card';

// LOCAL PARTS
import AttachmentPlaintext from '../../parts/downPayment/tools/AttachmentPlaintext';

// MAIN COMPONENT
const DownPayment = () => {

  // FORMIK
  const { values } = useFormikContext() || {};

  // MEMOS
  const { aryDownPayment } = useMemo(() => values || {}, [values]);

  let labelObject = {
    1: { label: 'DP By Credit Card', count: 0 },
    2: { label: 'DP By Check', count: 0 },
    3: { label: 'DP By Cash', count: 0 },
    4: { label: 'DP By Promissory Note', count: 0 },
    5: { label: 'DP By Wire', count: 0 },
    6: { label: 'DP By Product Cancellation Funds', count: 0 }
  };

  const dpLable = value => {
    labelObject[value].count++;
    return labelObject[value];
  };

  return values?.aryDownPayment?.length > 0 ? (
    <Card title="Down Payment / Deposit" body={<Form.Body>
      {aryDownPayment.sort((a, b) => {
        if (a.dp_type < b.dp_type) return -1;
        if (a.dp_type > b.dp_type) return 1;
        return 0;
      }).map((v, i) => {
        const dplabel = dpLable(v.dp_type);
        return (
          <AttachmentPlaintext
            key={`${v.down_payment_type_name}-${v.down_payment_id}-${i}`}
            index={i}
            label={`${dplabel.label} ${dplabel.count}`}
            value={v.dp_Amount}
            append={v.dp_description}
          />
        );
      })}
    </Form.Body>} />
  ) : null;
};

// EXPORT
export default DownPayment;
